import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserPen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.625 11.25H5.25C4.45435 11.25 3.69129 11.5661 3.12868 12.1287C2.56607 12.6913 2.25 13.4544 2.25 14.25V15.75",
			stroke: "#8DFF8B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0342 12.4696C16.333 12.1708 16.5008 11.7656 16.5008 11.3431C16.5008 10.9206 16.333 10.5154 16.0342 10.2166C15.7354 9.91785 15.3302 9.75 14.9077 9.75C14.4852 9.75 14.08 9.91785 13.7812 10.2166L10.7737 13.2256C10.5954 13.4038 10.4649 13.6241 10.3942 13.8661L9.76646 16.0186C9.74764 16.0831 9.74651 16.1516 9.7632 16.2167C9.77988 16.2818 9.81376 16.3412 9.8613 16.3888C9.90884 16.4363 9.96827 16.4702 10.0334 16.4869C10.0985 16.5036 10.1669 16.5024 10.2315 16.4836L12.384 15.8559C12.626 15.7852 12.8462 15.6547 13.0245 15.4764L16.0342 12.4696Z",
			stroke: "#8DFF8B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 8.25C9.15685 8.25 10.5 6.90685 10.5 5.25C10.5 3.59315 9.15685 2.25 7.5 2.25C5.84315 2.25 4.5 3.59315 4.5 5.25C4.5 6.90685 5.84315 8.25 7.5 8.25Z",
			stroke: "#8DFF8B",
			strokeOpacity: .3,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUserPen;
